const namespace = 'account';

export const SUBMIT_SETUP_TWO_FACTOR_AUTH = `${namespace}/SUBMIT_SETUP_TWO_FACTOR_AUTH`;
export const SET_TWO_FACTOR_AUTH_PASSWORD_ENTERED = `${namespace}/SET_TWO_FACTOR_AUTH_PASSWORD_ENTERED`;
export const SUBMIT_ACCOUNT_TWO_FACTOR_AUTH = `${namespace}/SUBMIT_ACCOUNT_TWO_FACTOR_AUTH`;
export const SUBMIT_UPDATE_USER_PASSWORD = `${namespace}/SUBMIT_UPDATE_USER_PASSWORD`;
export const SUBMIT_UPDATE_USER_EMAIL = `${namespace}/SUBMIT_UPDATE_USER_EMAIL`;
export const CONFIRM_USER_EMAIL = `${namespace}/CONFIRM_USER_EMAIL`;
export const UPDATE_NOTIFICATION_SETTING = `${namespace}/UPDATE_NOTIFICATION_SETTING`;
